import ApiService from '@/service/api.service.js'
import { apiV3 } from '@/service/v3/apiV3'
import * as types from './mutation-types'

export const getCurrentUser = async ({ commit }) => {
  commit(types.FETCH_CURRENTUSER_PENDING)
  try {
    const [v1Response, v3Response] = await Promise.all([
      ApiService.getCurrentUser(),
      apiV3.users.getCurrentUser(),
    ])

    if (v1Response.error) throw v1Response.error

    const userData = {
      ...v1Response.data,
      v3: v3Response.data.attributes,
    }

    commit(types.LOAD_CURRENTUSER, userData)
    commit(types.FETCH_CURRENTUSER_SUCCESS)
  } catch (err) {
    commit(types.FETCH_CURRENTUSER_FAILURE)
    console.error(err)
  }
}

export const getCurrentUserCompanies = ({ commit }) => {
  return ApiService.getCurrentUserCompanies().then((res) => {
    if (res.error) {
      throw Error(res.statusText)
    } else {
      commit(types.LOAD_CURRENTUSER_COMPANIES, res.data)
    }
  })
}

export const getCurrentCompany = async ({ commit, dispatch }) => {
  commit(types.FETCH_COMPANYDATA_PENDING)
  try {
    const res = await ApiService.getCurrentCompany()
    if (res.error) {
      commit(types.FETCH_COMPANYDATA_FAILURE)
      return
    }

    const v3Company = await apiV3.companies.getCompany(res.data.name_key)
    const companyData = {
      ...res.data,
      v3: v3Company.data.attributes,
    }

    commit(types.LOAD_COMPANYDATA, companyData)
    commit(types.FETCH_COMPANYDATA_SUCCESS)
  } catch (e) {
    commit(types.FETCH_COMPANYDATA_FAILURE)
    console.error(e)
  }
}

export const getCurrentUserDepartments = (context) => {
  return ApiService.getUserDepartments(context.state.currentUser.id)
    .then((res) => {
      if (res.error) {
        console.error(res.error)
      } else {
        context.commit(types.LOAD_CURRENTUSER_DEPARTMENTS, res.data.data)
      }
    })
    .catch((err) => {
      console.error(err)
    })
}

export const getCountryCodes = ({ commit }) => {
  return ApiService.getCountryCodes()
    .then((res) => {
      if (res.error) {
        throw Error(res.statusText)
      } else {
        commit(types.LOAD_COUNTRYCODES, res.data)
      }
    })
    .catch((err) => {
      console.error(err)
    })
}

export const getCurrentCompanyPositions = ({ commit }) => {
  return ApiService.getCurrentCompanyPositions()
    .then((res) => {
      if (res.error) {
        throw Error(res.statusText)
      } else {
        commit(types.LOAD_POSITIONS, res.data)
      }
    })
    .catch((err) => {
      console.error(err)
    })
}

export const getCurrentCompanyGroups = ({ commit }) => {
  return ApiService.getGroups()
    .then((res) => {
      if (res.error) {
        throw Error(res.statusText)
      } else {
        commit(types.LOAD_GROUPS, res.data)
      }
    })
    .catch((err) => {
      console.error(err)
    })
}

export const initializeAppData = async ({ dispatch }) => {
  await dispatch('getCurrentUser')
  await dispatch('getCurrentCompany')
  await dispatch('getCurrentUserCompanies')
  await dispatch('getCountryCodes')
  await dispatch('getCurrentCompanyPositions')
}
